@if(productVariant){
<div class="single-cart-button-wrapper">
  @if(stockLevel > 0){ @if(!qtyInCart[productVariant.id]){
  <button [disabled]="loading" (click)="addVariantToCart(productVariant.id, quantity)" pButton pRipple
    class="add-to-cart-btn icon-left" [class.item-in-cart]="qtyInCart[productVariant.id]"
    [class.loading-cart-btn]="loading" [style.height]="buttonHeight + 'px'">
    <div class="icon-wrapper">
      <img class="cart-icon" src="./../../../../assets/images/product/shopping_cart.svg" alt="shopping-cart-icon" />
    </div>

    <div class="price-block">
      <div class="add-to-cart-line" [class.bold]="!qtyInCart[productVariant.id]">
        @if(!qtyInCart[productVariant.id]){
        <span>Add to cart</span>
        } @else {
        <span>{{
            qtyInCart[productVariant.id]
          }}
          item@if(qtyInCart[productVariant.id] > 1){s} in cart</span>
        }
      </div>

      @if(qtyInCart[productVariant.id]){
      <div class="price-line">
        <span>
          @if(productVariant){ @if(productVariant.priceWithTax |
          formatPrice:qtyInCart[productVariant.id] | async; as productPrice){
          {{ productPrice }}
          } @else {
          <div class="loader-wrapper p-unset">
            <p-progressSpinner styleClass="c-loader medium centered-vertically " strokeWidth="2"
              fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </div>
          } }
        </span>
      </div>
      }
    </div>
  </button>
  } @else {
  <div class="in-cart-item-quantity-selector">
    <button [loading]="loading" (click)="
        decrementVariantFromCart(
          productVariant.id,
          qtyInCart[productVariant.id]
        )
      " pButton pRipple class="c-button icon-only decrement">
      @if(!loading){
      <i class="pi pi-minus"></i>
      }
    </button>
    <div class="info-content">
      <div class="quantity-line">Qty: {{ qtyInCart[productVariant.id] }}</div>

      <div class="price-line">
        @if(productVariant){ @if(productVariant.priceWithTax |
        formatPrice:qtyInCart[productVariant.id] | async; as productPrice){
        {{ productPrice }}
        } @else {
        <div class="loader-wrapper p-unset">
          <p-progressSpinner styleClass="c-loader medium centered-vertically " strokeWidth="2"
            fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
        </div>
        } }
      </div>
    </div>
    <button [loading]="loading" [disabled]="qtyInCart[productVariant.id] > stockLevel || qtyInCart[productVariant.id] == stockLevel" (click)="
        incrementVariantInCart(productVariant.id, qtyInCart[productVariant.id])
      " pButton pRipple class="c-button icon-only increment increment-decrement-icon">
      @if(!loading){
      <i class="pi pi-plus"></i>
      }
    </button>
  </div>
  } } @else { @if(itemRequested){
  <button [disabled]="true" pButton pRipple class="add-to-cart-btn icon-left no-stock"
    [class.loading-cart-btn]="loading" [style.height]="buttonHeight + 'px'">
    <div class="icon-wrapper">
      <img class="cart-icon" src="./../../../../../assets/images/product/comment.svg" alt="shopping-cart-icon" />
    </div>

    <div class="price-block">
      <div class="add-to-cart-line bold">
        <span>ITEM REQUESTED</span>
      </div>
    </div>
  </button>
  } @else {
  <button [disabled]="loading"  (click)="openRequestPartDialog()" pButton pRipple
    class="add-to-cart-btn icon-left no-stock" [class.loading-cart-btn]="loading" [style.height]="buttonHeight + 'px'">
    <div class="icon-wrapper">
      <img class="cart-icon" src="./../../../../../assets/images/product/comment.svg" alt="shopping-cart-icon" />
    </div>

    <div class="price-block">
      <div class="add-to-cart-line bold">
        <span>REQUEST ITEM</span>
      </div>
    </div>
  </button>
  } }
</div>

} @if(searchResult){
<div class="single-cart-button-wrapper">
  @if(searchResult.inStock){ @if(!qtyInCart[searchResult.productVariantId]){
  <button [disabled]="loading" (click)="addVariantToCart(searchResult.productVariantId, quantity)" pButton pRipple
    class="add-to-cart-btn icon-left" [class.item-in-cart]="qtyInCart[searchResult.productVariantId]"
    [class.loading-cart-btn]="loading" [style.height]="buttonHeight + 'px'">
    <div class="icon-wrapper">
      <img class="cart-icon" src="./../../../../../assets/images/product/shopping_cart.svg" alt="shopping-cart-icon" />
    </div>

    <div class="price-block">
      <div class="add-to-cart-line" [class.bold]="!qtyInCart[searchResult.productVariantId]">
        @if(!qtyInCart[searchResult.productVariantId]){
        <span>Add to cart</span>
        } @else {
        <span>{{
            qtyInCart[searchResult.productVariantId]
          }}
          item@if(qtyInCart[searchResult.productVariantId] > 1){s} in cart</span>
        }
      </div>

      @if(qtyInCart[searchResult.productVariantId]){
      <div class="price-line">
        <span>
          @if(searchResult.priceWithTax |
          formatSearchResultPriceTemplate:qtyInCart[searchResult.productVariantId]
          | async; as productPrice){
          {{ productPrice }}
          } @else {
          <div class="loader-wrapper p-unset">
            <p-progressSpinner styleClass="c-loader medium centered-vertically " strokeWidth="2"
              fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </div>
          }
        </span>
      </div>
      }
    </div>
  </button>

  } @else {
  <div class="in-cart-item-quantity-selector">
    <button [loading]="loading" (click)="
        decrementVariantFromCart(
          searchResult.productVariantId,
          qtyInCart[searchResult.productVariantId]
        )
      " pButton pRipple class="c-button icon-only decrement">
      @if(!loading){
      <i class="pi pi-minus"></i>
      }
    </button>
    <div class="info-content">
      <div class="quantity-line">
        Qty: {{ qtyInCart[searchResult.productVariantId] }}
      </div>

      <div class="price-line">
        @if(searchResult.priceWithTax |
        formatSearchResultPriceTemplate:qtyInCart[searchResult.productVariantId]
        | async; as productPrice){
        {{ productPrice }}
        } @else {
        <div class="loader-wrapper p-unset">
          <p-progressSpinner styleClass="c-loader medium centered-vertically " strokeWidth="2"
            fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
        </div>
        }
      </div>
    </div>
   
    <button [loading]="loading" [disabled]="qtyInCart[searchResult.productVariantId] > stockLevel || qtyInCart[searchResult.productVariantId] == stockLevel" (click)="
        incrementVariantInCart(
          searchResult.productVariantId,
          qtyInCart[searchResult.productVariantId]
        )
      " pButton pRipple class="c-button icon-only increment increment-decrement-icon">
      @if(!loading){
      <i class="pi pi-plus"></i>
      }
    </button>
  </div>

  } } @else { @if(itemRequested){
  <button [disabled]="true" pButton pRipple class="add-to-cart-btn icon-left no-stock"
    [class.loading-cart-btn]="loading" [style.height]="buttonHeight + 'px'">
    <div class="icon-wrapper">
      <img class="cart-icon" src="./../../../../../assets/images/product/comment.svg" alt="shopping-cart-icon" />
    </div>

    <div class="price-block">
      <div class="add-to-cart-line bold">
        <span>ITEM REQUESTED</span>
      </div>
    </div>
  </button>

  } @else {
  <button (click)="openRequestPartDialog()" [disabled]="loading" pButton pRipple
    class="add-to-cart-btn icon-left no-stock" [class.loading-cart-btn]="loading" [style.height]="buttonHeight + 'px'">
    <div class="icon-wrapper">
      <img class="cart-icon" src="./../../../../../assets/images/product/comment.svg" alt="shopping-cart-icon" />
    </div>

    <div class="price-block">
      <div class="add-to-cart-line bold">
        <span>REQUEST ITEM</span>
      </div>
    </div>
  </button>

  } }
</div>
} @if(!productVariant && !searchResult){
<div class="single-cart-button-wrapper">
  @if((quantity == 1 || quantity == undefined) && !showPrice){
  <button (click)="addVariantToCart(productVariant, quantity)" pButton pRipple class="add-to-cart-btn icon-left"
    [class.item-in-cart]="itemInCart" [style.height]="buttonHeight + 'px'">
    <div class="icon-wrapper">
      <img class="cart-icon" src="./../../../../assets/images/product/shopping_cart.svg" alt="shopping-cart-icon" />
    </div>

    <div class="price-block">
      @if(!itemInCart){
      <div class="add-to-cart-line">
        <span>Add to cart</span>
      </div>
      } @else{
      <div class="total-items-in-cart-line">
        <span>3 items in cart</span>
      </div>

      } @if(!itemInCart){
      <div class="price-line">
        <span>
          @if(searchResult){ @if(searchResult.priceWithTax |
          formatSearchResultPriceTemplate | async; as productPrice){
          {{ productPrice }}
          } @else {
          <div class="loader-wrapper p-unset">
            <p-progressSpinner styleClass="c-loader medium centered-vertically " strokeWidth="2"
              fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </div>
          } }
        </span>
      </div>
      }
    </div>
  </button>
  } @else {

  <button (click)="addVariantToCart(productVariant, quantity)" pButton pRipple
    class="add-to-cart-btn multi-quantity-btn icon-left" [class.item-in-cart]="itemInCart"
    [style.height]="buttonHeight + 'px'">
    <div class="icon-wrapper">
      <img class="cart-icon" src="./../../../../assets/images/product/shopping_cart.svg" alt="shopping-cart-icon" />
    </div>
    <div class="price-block">
      @if(!itemInCart){
      <div class="add-to-cart-line">
        <span>Add to cart</span>
      </div>
      } @else {
      <div class="total-items-in-cart-line">
        <span>3 items in cart</span>
      </div>
      }
      <div class="price-line">
        <span>
          @if(searchResult.priceWithTax | formatSearchResultPriceTemplate |
          async; as productPrice){
          {{ productPrice }}
          } @else {
          <div class="loader-wrapper p-unset">
            <p-progressSpinner styleClass="c-loader medium centered-vertically " strokeWidth="2"
              fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </div>
          }
        </span>
      </div>
    </div>
  </button>
  }
</div>
}

